import { BaseReq, BaseResp, PaginationReq, PaginationResp, UpdaterResp } from "@/core/interface";

export class ListRecord extends BaseReq {
  uuid: string = ""; // 唯一ID
  projectFundId: string | undefined = undefined; // 工程款项ID
  budget: number = 0; // 方案预算
  ratio: number = 0; // 占比
  remark: string = ""; // 备注
}

export class SolutionReq extends BaseReq {
  projectId: string | undefined = undefined; // 项目ID
  totalBudget: number = 0; // 项目总预算
  responsibleTenantUserId: string | undefined = undefined; // 预算负责人ID
  remark: string = ""; // 备注
  list: ListRecord[] = []; // 类目明细
}

export class SolutionPageReq extends PaginationReq {
  name: string | undefined = undefined; // 项目名称
  cooperationCompanyId: string | undefined = undefined; // 客户ID
  projectTypeId: string | undefined = undefined; // 项目类型ID
  provinceId: number | undefined = undefined; // 所在地区 - 省ID
  cityId: number | undefined = undefined; // 所在地区 - 市ID
  districtId: number | undefined = undefined; // 所在地区 - 区ID
  salesmanTenantUserId: string | undefined = undefined; // 业务员ID
  validStatus: string | undefined = undefined; // 项目状态
  flowStatus: string | undefined = undefined; // 审批状态
}

export class SolutionListRecord extends UpdaterResp {
  id: number = 0; // 技术方案ID
  bidNo: string = ""; // 技术方案编号
  projectName: string = ""; // 项目名称
  totalBudget: number = 0; // 方案总预算
  responsibleTenantUserId: string = ""; // 预算负责人ID
  responsibleTenantUserName: string = ""; // 预算负责人姓名
  remark: string = ""; // 备注
  validStatus: string = ""; // 生效状态Code
  validStatusName: string = ""; // 生效状态名称
  flowStatus: string = ""; // 审批状态Code
  flowStatusName: string = ""; // 审批状态名称
}

export class SolutionPageResp extends PaginationResp<SolutionListRecord> {}

export class SolutionDetailResp extends UpdaterResp {
  id: string = ""; // 技术方案ID
  bizNo: string = ""; // 技术方案编号
  projectId: string = ""; // 项目ID
  projectName: string = ""; // 项目名称
  totalBudget: number = 0; // 项目总预算
  responsibleTenantUserId: string = ""; // 预算负责人ID
  responsibleTenantUserName: string = ""; // 预算负责人姓名
  remark: string = ""; // 备注
  list: ListRecord[] = []; // 类目明细
  apiList: ListRecord[] = []; // 类目明细
}

// 技术方案选择器
export class SolutionSimplePageReq extends PaginationReq {
  skillSolutionBizNo: string = "";
  projectId: string = "";
}

export class SolutionSimpleRecord extends UpdaterResp {
  id: number = 0; // 技术方案ID
  bizNo: string = ""; // 技术方案编号
  totalBudget: number = 0; // 方案总预算
  responsibleTenantUserName: string = ""; // 预算负责人姓名
  remark: string = ""; // 备注
  validStatus: string = ""; // 生效状态Code
  validStatusName: string = ""; // 生效状态名称
}

export class SolutionSimplePageResp extends PaginationResp<SolutionSimpleRecord> {}
